import React, {Suspense, useState, useEffect} from 'react';
import {RefButton} from "../like-button-ref/like-button-ref";
import {useStyles} from "./style";
import {HeaderProps} from "./types";
import {StaticImage} from "gatsby-plugin-image";
import {Brands} from "../brands/brands";
import {PromoBanner} from "../promo-banner/promo-banner";
import classNames from "classnames";
import {ContactUsForm} from '../forms/contact-us/contact-us-form';
import {ContactUsExtendedForm} from '../forms/contact-us-extended/contact-us-extended-form';
import {BannersCarousel} from "../banners-carousel/banners-carousel";
import {BrandingForm} from '../forms/pricing/branding/branding-form';
const LottieAnimation = React.lazy(() => import('../lottie-animation/phone'));

export const Header = (props: HeaderProps) => {
    const classes = useStyles();
    const [modalIsOpen, setIsOpenModal] = useState(false);
    const [display, setDisplay] = useState<boolean>();

    useEffect(() => {
        setDisplay(window.innerWidth >= 1200);
    }, []);

    function modalOpenHandle(e: Event) {
        e.preventDefault();
        setIsOpenModal(true);
    }

    function modalCloseHandle() {
        setIsOpenModal(false);
    }

    function setForm(type?: string) {
      switch (type) {
        case "contact-us-extended":
          return <ContactUsExtendedForm isOpen={modalIsOpen} closeHandle={modalCloseHandle} />
        break;
        case "branding":
          return <BrandingForm isOpen={modalIsOpen} closeHandle={modalCloseHandle} />
        break;
        default:
          return <ContactUsForm isOpen={modalIsOpen} closeHandle={modalCloseHandle} />;
      }
    }

    return (
        <header
            className={
                classNames(
                    "headerInside",
                    classes.headerContainer,
                    {
                        [classes.withBanner]: props.banner,
                        [classes.withBubbles]: props.bubble,
                        [classes.bubblesType1]: props.bubbleType === 1,
                        [classes.bubblesType2]: props.bubbleType === 2,
                        [classes.withLight]: props.light,
                        [classes.withAdaptiveImg]: props.adaptiveImg
                    }
                )
            }
        >
            {props.banner &&
                <div className={classes.promoBannerContainer}>
                    <PromoBanner
                        bannerMediaUrl={props.banner?.bannerMediaUrl}
                        bannerMediaText={props.banner?.bannerMediaText}
                        bannerText={props.banner?.bannerText}
                        bannerButtonText={props.banner?.bannerButtonText}
                    />
                </div>
            }
            <div
                className={
                    classNames(
                        classes.headerTop,
                        { [classes.headerTopFlexStart]: props.alignment === "flex-start"}
                    )
                }
            >
                <div className="headerTextContainer">
                    <h1
                        className={
                            classNames(
                                classes.headerTitle,
                                {[classes.blackStyle]: props.variant === "white"}
                            )
                        }
                    >
                        {props.title}
                    </h1>
                    {props.subtitle &&
                        <div
                            className={
                                classNames(
                                    "h3 " + classes.headerSubtitle,
                                    {[classes.blackStyle]: props.variant === "white"}
                                )
                            }
                        >
                            {props.subtitle}
                        </div>
                    }
                    {props.description &&
                        <div
                            className={
                                classNames(
                                    "h4 " + classes.headerDescription,
                                    {[classes.blackStyle]: props.variant === "white"}
                                )
                            }
                        >
                            {props.description}
                        </div>
                    }
                    {props.button && <div className={classes.headerButtonsContainer}>
                        {props.button?.map((el, idx) => (
                            <RefButton
                                key={idx}
                                text={el.text}
                                style={el.style}
                                href={el.href}
                                variant={el.variant}
                                size={el.size}
                                outlined={el.outlined}
                                onClick={(e: Event) => el.tag === "button" ? modalOpenHandle(e) : undefined}
                                offset={el.offset}
                                classNames={el.variant === "secondary" ? classes.headerSecondaryBtn : ""}
                                tag={el.tag}
                            />
                        ))}
                    </div>}
                </div>
                <div className={classNames(
                    classes.headerImgContainer,
                    {[classes.headerImgVisible]: props.adaptiveImg},
                    "headerRightSection"
                )}
                >
                    {props.img && !props.embeddedComponent &&
                        <img className={classes.headerImg} src={props.img} alt=""/>
                    }
                    {display && !props.img && !props.embeddedComponent &&
                        <div className={classes.headerAnimation}>
                            <Suspense fallback={<StaticImage placeholder="blurred" width={600} height={600} src={"../../images/pages/index/phone.png"} alt={''}/>}>
                                <LottieAnimation />
                            </Suspense>
                        </div>
                    }
                    {props.embeddedComponent && !props.img &&
                        props.embeddedComponent
                    }
                </div>
            </div>
            {props.carousel &&
                <div className={
                    classNames(
                        classes.headerCarousel,
                        {[classes.headerCarouselWhiteStyle]: props.variant === "blue"}
                    )
                }
                >
                    <Brands
                        title={props.carousel?.title}
                        items={props.carousel?.items}
                        lgItemsCount={props.carousel.lgItemsCount}
                        mdItemsCount={props.carousel.mdItemsCount}
                        smItemsCount={props.carousel.smItemsCount}
                    />
                </div>
            }
            {setForm(props.formType)}
        </header>
    );
};
